// @flow
import MobileDetect from 'mobile-detect'

export function buildUrl(url: string) {
  const md = new MobileDetect(window.navigator.userAgent)
  const prefix = md.is('AndroidOS') ? 'wink://wink/' : 'wink://'
  return prefix + url
}



// WEBPACK FOOTER //
// ./src/services/linking.js